export function formatDate(date, type = "short") {
  if (!date) return "";

  return new Intl.DateTimeFormat("pt-BR", { dateStyle: type }).format(
    new Date(date.replace(" ", "T"))
  );
}
